<template>
    <div>
        <div class="form flex a-center j-between mt--23">
            <div class="form-left ml--30">
                <el-form :inline="true" :model="searchForm">
                    <el-form-item label="公司名称:" prop="enterpriseName" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.enterpriseName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="驾驶员手机号:" prop="phone" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.phone" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="驾驶员姓名:" prop="driverName" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.driverName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="紧急联系人姓名:" prop="emergencyContact" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.emergencyContact" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="form-right mr--24 mb--22">
                <el-button class="search-button h--40 w--90 fs--14" icon="el-icon-search" type="primary" size="small"
                    @click="search">查询</el-button>
                <el-button @click="reset" icon="el-icon-refresh-right" class="reset-button h--40 w--90 fs--14"
                    size="small">重置</el-button>
            </div>
        </div>
        <div class="table-box ml--30 mt--23 mr--30">
            <el-table :data="tableData" border stripe style="width: 100%" :element-loading-text="'正在加载...'">
                <el-table-column type="index" width="55" label="序号"></el-table-column>
                <el-table-column prop="driverName" label="机动车驾驶员姓名"></el-table-column>
                <el-table-column prop="enterpriseName" label="车辆所属公司"></el-table-column>
                <el-table-column prop="drivingLicenseNumber" label="机动车驾驶证号"></el-table-column>
                <el-table-column prop="mailingAddress" label="驾驶员通信地址"></el-table-column>
                <el-table-column prop="emergencyContact" label="紧急情况联系人"></el-table-column>
                <el-table-column prop="emergencyPhone" label="紧急情况联系人电话"></el-table-column>
                <el-table-column prop="phone" label="驾驶员手机号"></el-table-column>
                <el-table-column prop="contractingCompany" label="驾驶员合同签订公司"></el-table-column>
                <el-table-column label="操作">
                    <template #default="{ row }">
                        <el-button  v-permission="33" @click="showDetail(row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="relative mt--23 flex j-end">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchForm.page" background layout="total,sizes,prev, pager, next,jumper"
                    :total="searchForm.total">
                </el-pagination>
            </div>
        </div>
        <DetailModal ref="detailModal" />
    </div>
</template>

<script>
import DetailModal from "./component/detailModal"
import { getDriverInfo, getDriverList } from './service'

export default {
    components: {
        DetailModal
    },
    data() {
        return {
            searchForm: {
                total: 0,
                page: 1,
                pageSize: 10
            },
            tableData: [],
        };
    },
    computed: {
        height() {
            return this.$baseTableHeight()
        },
    },
    created() {
        this.$checkPermission(32)
        this.getTableList()
    },
    methods: {
        reset() {
            this.searchForm = {
                total: 0,
                page: 1,
                pageSize: 10
            }
            this.getTableList()
        },
        search() {
            this.getTableList()
        },
        exportExcell() {

        },
        handleSizeChange(e) {
            this.searchForm.pageSize = e
            this.getTableList()
        },
        handleCurrentChange(e) {
            this.searchForm.page = e
            this.getTableList()
        },
        getTableList() {
            let obj = { ...this.searchForm }
            delete obj.total
            getDriverList(obj).then(res => {
                this.tableData = res.records
                this.searchForm.total = res.total
            })
        },
        showDetail(row) {
            getDriverInfo(row.id).then(res=>{
                this.$refs.detailModal.initData(res)
            })
        },
    }
}
</script>
<style scoped lang="less">
::v-deep .el-form-item .el-input__inner {
    width: 240px;
}
</style>